export default "__VITE_ASSET__BOgZ7BKP__"